







































import DSelect from '~/components/atoms/DS2/DSelect'
import { PropType } from '@nuxtjs/composition-api'

// TODO: category_v2 ServiceSearchFormV2配下のディレクトリに移動させよう
export default {
  name: 'OptionTypePriceRange',
  components: {
    DSelect
  },
  props: {
    selectedUnitPriceMin: {
      type: String as PropType<string>,
      default: ''
    },
    selectedUnitPriceMax: {
      type: String as PropType<string>,
      default: ''
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    },
    master: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
